import { ActionIcon, Stack, Text, Tooltip } from '@mantine/core'
import { IconAlertTriangle } from '@tabler/icons-react'
import { useIntl } from 'react-intl'
import { EdgeClientLastActionError } from '@/types/device'
import {
  getEdgeClientErrorCategoryMessageId,
  getEdgeClientFallbackMessageId
} from '../edgeClientErrorMessages'

type EdgeClientActionFailureIndicatorProps = {
  error: EdgeClientLastActionError
}

export const EdgeClientActionFailureIndicator = ({
  error
}: EdgeClientActionFailureIndicatorProps) => {
  const intl = useIntl()

  const friendlyErrorMessage = intl.formatMessage({
    id:
      getEdgeClientErrorCategoryMessageId(error.category) ||
      getEdgeClientFallbackMessageId(error.action)
  })

  const failedActionLabel = intl.formatMessage({
    id:
      error.action === 'restart'
        ? 'devices.edgeClient.lastActionFailed.restart'
        : 'devices.edgeClient.lastActionFailed.update'
  })

  return (
    <Tooltip
      w={280}
      label={
        <Stack gap={2}>
          <Text size="xs">{friendlyErrorMessage}</Text>
          {error.detail && (
            <Text size="xs" c="dimmed">
              {error.detail}
            </Text>
          )}
        </Stack>
      }
      events={{ hover: true, focus: true, touch: false }}
      multiline
    >
      <ActionIcon
        color="yellow"
        variant="light"
        size="sm"
        radius="xl"
        aria-label={failedActionLabel}
      >
        <IconAlertTriangle style={{ width: '70%', height: '70%' }} />
      </ActionIcon>
    </Tooltip>
  )
}
